import axios, { AxiosRequestConfig, AxiosInstance, AxiosPromise } from 'axios';
import Cookies from 'js-cookie';

// import usestorage from 'app/utils/storage';

const { REACT_APP_API_GATEWAY_URL } = process.env;

function request<T = any>({ url, headers, baseURL, ...options }: AxiosRequestConfig, skipToken = false): AxiosPromise<T> {
  // const request = ({ url, headers, baseURL, ...options }: AxiosRequestConfig): AxiosPromise => {
  const autoDiscover: any = Cookies.get('autoDiscover');
  const token = Cookies.get('token');

  //   const storage = usestorage('sessionStorage');

  const requestOptions: AxiosRequestConfig = {
    baseURL: baseURL || (autoDiscover && autoDiscover.apiGatewayUrl) || REACT_APP_API_GATEWAY_URL,
  };

  const instance: AxiosInstance = axios.create(requestOptions);

  //   instance.interceptors.response.use(
  //     (response) => {
  //       return response;
  //     },
  //     (error) => {
  //       if (error.response.status === 401) {
  //         storage.set('redirect_url', `/${window.location.pathname.substring(1)}`);
  //         window.location.href = '/login';
  //       }
  //       return error;
  //     }
  //   );

  if (!skipToken && token) {
    instance.defaults.headers.common.Authorization = `Bearer ${token}`;
  }

  const params = {
    url,
    ...options,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'Accept': 'application/json',
      ...headers,
    },
  };

  return instance(params);
}

export default request;
